(() => {
  const box = document.querySelector('[data-signature-product]');
  if (!box) return;
  const variants = JSON.parse(box.querySelector('[data-signature-variants]').textContent);
  const settings = JSON.parse(box.querySelector('[data-signature-settings]').textContent);
  const form = box.querySelector('form');
  const buttons = [...box.querySelectorAll('[data-signature-option]')];
  const cartButton = box.querySelector('[data-signature-cart]');
  const price = box.querySelector('[data-signature-price]');
  const stock = box.querySelector('[data-signature-stock]');
  const choice = box.querySelector('[data-signature-choice]');
  const message = box.querySelector('[data-signature-message]');
  const viewCart = box.querySelector('[data-signature-view-cart]');
  const updateCartCount = async () => {
    try {
      const response = await fetch(`${settings.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-svelteva-cart-count]').forEach(node => {
        node.textContent = String(cart.item_count);
        node.hidden = cart.item_count < 1;
        const link = node.closest('a');
        if (link) link.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
      });
    } catch (_) {}
  };
  const input = box.querySelector('[data-variant-id]');
  const instalment = box.querySelector('[data-klarna-installment]');
  const klarna = box.querySelector('[data-klarna]');
  const hero = document.querySelector('[data-signature-hero]');
  const colourName = box.querySelector('[data-selected-colour]');
  const money = cents => new Intl.NumberFormat(settings.locale, {
    style: 'currency', currency: settings.currency
  }).format(cents / 100);
  let options = buttons.filter(b => b.getAttribute('aria-pressed') === 'true')
    .sort((a, b) => Number(a.dataset.signatureOption) - Number(b.dataset.signatureOption))
    .map(b => b.dataset.optionValue);
  let current = variants.find(v => String(v.id) === input.value);
  let submitting = false;
  const render = () => {
    current = variants.find(v => v.options.every((value, index) => value === options[index]));
    buttons.forEach(b => b.setAttribute('aria-pressed', String(options[Number(b.dataset.signatureOption)] === b.dataset.optionValue)));
    input.value = current ? current.id : '';
    input.disabled = !current;
    cartButton.disabled = submitting || !current?.available;
    if (choice) choice.textContent = options.map(value => { const key=value.trim().toUpperCase(); return /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)$/.test(key) ? ({'2XL':'XXL','XXXL':'3XL'})[key] || key : value === 'Navy' ? 'Navy Blue' : value; }).join(' / ');
    const selectedColour = buttons.find(b => b.dataset.colourName && b.getAttribute('aria-pressed') === 'true');
    if (selectedColour) {
      if (colourName) colourName.textContent = selectedColour.dataset.colourName;
      if (hero && selectedColour.dataset.colourImage) {
        if (hero.getAttribute('src') !== selectedColour.dataset.colourImage) {
          hero.removeAttribute('srcset');
          hero.setAttribute('src', selectedColour.dataset.colourImage);
        }
        hero.setAttribute('alt', `${settings.name} — ${selectedColour.dataset.colourName}`);
      }
    }
    stock.textContent = !current ? 'This combination is unavailable' : current.available ? 'In stock' : 'Sold out in this variant';
    stock.style.color = current?.available ? '' : 'var(--berry)';
    price.textContent = current ? money(current.price) : '—';
    if (instalment) instalment.textContent = current ? money(current.price / 3) : '—';
    if (klarna) klarna.hidden = !current;
    cartButton.textContent = submitting ? 'ADDING…' : current?.available ? `ADD TO CART — ${money(current.price)}` : 'SOLD OUT';
    if (current) {
      box.dataset.productPrice = String(current.price / 100);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState(null, '', url);
    }
  };
  buttons.forEach(button => button.addEventListener('click', () => {
    options[Number(button.dataset.signatureOption)] = button.dataset.optionValue;
    message.textContent = '';
    if (viewCart) viewCart.hidden = true;
    render();
  }));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !current?.available) return;
    submitting = true;
    message.textContent = '';
    if (viewCart) viewCart.hidden = true;
    render();
    try {
      const response = await fetch(`${settings.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added. Please try again.');
      message.textContent = 'Added to your bag.';
      if (viewCart) viewCart.hidden = false;
      await updateCartCount();
      document.dispatchEvent(new CustomEvent('svelteva:cart-updated', { detail: result }));
    } catch (error) {
      message.textContent = error.message || 'Please try again.';
    } finally {
      submitting = false;
      render();
    }
  });
  render();
})();
